import { createElement, forwardRef } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import invariant from 'invariant';

import useFetch from 'Hooks/useFetch';

export default function withFetch(Component) {
  const displayName = `withFetch(${ (Component.displayName || Component.name || 'Component') })`;

  const WithFetch = forwardRef((props, ref) => {
    const fetchContext = useFetch();
    invariant(fetchContext, `You should not use <${displayName} /> outside a <FetchProvider />`);
    return createElement(Component, {
      fetch: fetchContext,
      ref,
      ...props
    });
  });

  WithFetch.displayName = displayName;
  WithFetch.WrappedComponent = Component;

  return hoistNonReactStatics(WithFetch, Component);
}
